import axiosInstance from "./api_helper";

const unitesService = {
    
    list: async () => {
        return axiosInstance.get(`/api/unites/list`);
    },
    create: async (payload) => {
        return await axiosInstance.post('/api/unites', payload);
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/unites/${payload.id}`, JSON.stringify(payload.data));
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/unites/${id}`);
    },
};

export default unitesService;